// ( function() {
// 	var youtube = document.querySelectorAll( ".youtube" );	
// 	for (var i = 0; i < youtube.length; i++) {		
// 		var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/sddefault.jpg";		
// 		var image:any = new Image();
// 				image.src = source;
// 				image.width = "540";
// 				image.height = "302";
// 				image.className = "img-fluid";
// 				image.addEventListener( "load", function() {
// 					youtube[ i ].appendChild( image );
// 				}( i ) );		
// 				youtube[i].addEventListener( "click", function() {
// 					var iframe = document.createElement( "iframe" );
// 							iframe.setAttribute( "frameborder", "0" );
// 							iframe.setAttribute( "allowfullscreen", "" );
// 							iframe.setAttribute( "allow", "autoplay");
// 							iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?autoplay=1&rel=0&showinfo=0" );
// 							this.innerHTML = "";
// 							this.appendChild( iframe );
// 				} );	
// 	};	
// } )();

export function youtube() 
{
    const youtubeElements = Array.from(document.querySelectorAll( ".youtube" )) as HTMLElement[];	

    for (const youtube of youtubeElements) 
    {
		const source = `https://img.youtube.com/vi/${youtube.dataset.embed}/sddefault.jpg`;		
		const image = new Image();
        image.src = source;

        image.addEventListener("load", () => {  youtube.appendChild( image ); });		

        youtube.addEventListener("click", (e) => {
            var youtubeSrc = (e.currentTarget as HTMLElement).getAttribute('data-embed');
            const iframe = globalThis.document.createElement( "iframe" );
            iframe.setAttribute( "frameborder", "0" );
            iframe.setAttribute( "allowfullscreen", "" );
            iframe.setAttribute( "allow", "autoplay");
            iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ youtubeSrc +"?autoplay=1&rel=0&showinfo=0" );
            youtube.innerHTML = "";
            youtube.appendChild( iframe );
        });	
	};	
}
